// import "./HrArea.css";
import { useContext, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import axios from "axios";
import { motion } from "framer-motion";
import { Form, Input, Radio, Button, Upload, Typography, Card } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const { TextArea } = Input;
const { Title, Paragraph } = Typography;

export default function HrArea() {
    const { authData, backUrl } = useContext(AuthContext);
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [isFile, setIsFile] = useState(false);
    const [announcement_file, setAnnouncement_File] = useState(null);

    const handleSubmit = async () => {
        if (!title.trim() || !content.trim()) {
            toast.error("Please enter both title and content.");
            return;
        }

        const formData = new FormData();
        formData.append("title", title);
        formData.append("content", content);
        formData.append("is_file", isFile);
        if (isFile && announcement_file) {
            formData.append("announcement_file", announcement_file);
        }

        try {
            const response = await axios.post(
                `${backUrl}/api/hr/announcements/`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${authData.access}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (response.status === 201 || response.status === 200) {
                toast.success("Announcement posted successfully!");
                setTitle("");
                setContent("");
                setIsFile(false);
                setAnnouncement_File(null);
            } else {
                toast.error("Failed to post announcement.");
            }
        } catch (error) {
            console.error("Error posting announcement:", error);
            toast.error("An error occurred while posting the announcement.");
        }
    };

    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

            <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <div style={{ maxWidth: 700, margin: "0 auto", padding: "20px" }}>
                    <Card
                        style={{
                            borderRadius: "12px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                            padding: "2rem",
                        }}
                    >
                        <Title
                            level={4}
                            style={{
                                textAlign: "center",
                                marginBottom: 20,
                                color: "#0e497b",
                            }}
                        >
                            Post Announcement
                        </Title>

                        <Form layout="vertical" onFinish={handleSubmit}>
                            {/* Title */}
                            <Form.Item label="Title" required>
                                <Input
                                    placeholder="Enter announcement title"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                />
                            </Form.Item>

                            {/* Content */}
                            <Form.Item label="Content" required>
                                <TextArea
                                    rows={4}
                                    placeholder="Main body of the announcement"
                                    value={content}
                                    onChange={(e) => setContent(e.target.value)}
                                />
                            </Form.Item>

                            {/* Upload File Option */}
                            <Form.Item label="Want to Upload a File?">
                                <Radio.Group
                                    value={isFile}
                                    onChange={(e) => setIsFile(e.target.value)}
                                    optionType="button"
                                    buttonStyle="solid"
                                    style={{ marginBottom: 12 }}
                                >
                                    <Radio value={true}>Yes</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>

                                {isFile && (
                                    <div>
                                        <Upload
                                            beforeUpload={(file) => {
                                                setAnnouncement_File(file);
                                                return false; // prevent auto-upload
                                            }}
                                            maxCount={1}
                                            showUploadList={false}
                                        >
                                            <Button icon={<UploadOutlined />}>
                                                Select File
                                            </Button>
                                        </Upload>
                                        {announcement_file && (
                                            <Paragraph
                                                type="secondary"
                                                style={{ marginTop: 8 }}
                                            >
                                                Selected: {announcement_file.name}
                                            </Paragraph>
                                        )}
                                    </div>
                                )}
                            </Form.Item>

                            {/* Submit */}
                            <Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    block
                                    style={{
                                        backgroundColor: "#0e497b",
                                        borderRadius: 8,
                                        fontSize: 16,
                                        height: 45,
                                    }}
                                >
                                    Make Announcement
                                </Button>
                            </Form.Item>
                        </Form>
                    </Card>
                </div>
            </motion.div>
        </>
    );
}
